import React from 'react';
import { Plus, FileText, Video, Shield, Bell, Users, Calendar, MessageSquare, Settings, BarChart3, Package, Layers } from 'lucide-react';
import Button from '../../../components/ui/Button';
import { Link } from 'react-router-dom';

const QuickActions = ({ onRefresh, onAction }) => {
  const quickActions = [
    {
      icon: Plus,
      label: 'Nouvelle Propriété',
      color: 'bg-blue-500 hover:bg-blue-600',
      onClick: () => onAction?.('new-property')
    },
    {
      icon: Video,
      label: 'Gestion Vidéos',
      color: 'bg-purple-500 hover:bg-purple-600',
      onClick: () => onAction?.('video-management')
    },
    {
      icon: Package,
      label: 'Import .obj 3D',
      color: 'bg-indigo-600 hover:bg-indigo-700',
      onClick: () => onAction?.('obj-import')
    },
    {
      icon: Calendar,
      label: 'RDV Notaires',
      color: 'bg-green-500 hover:bg-green-600',
      onClick: () => onAction?.('notary-appointments')
    },
    {
      icon: MessageSquare,
      label: 'Demandes Clients',
      color: 'bg-orange-500 hover:bg-orange-600',
      onClick: () => onAction?.('user-requests')
    },
    {
      icon: FileText,
      label: 'Vérification Documents',
      color: 'bg-teal-500 hover:bg-teal-600',
      onClick: () => onAction?.('document-verification')
    },
    {
      icon: Users,
      label: 'Gestion Agents',
      color: 'bg-indigo-500 hover:bg-indigo-600',
      onClick: () => onAction?.('agent-management')
    },
    {
      icon: Shield,
      label: 'Workflow Approbation',
      color: 'bg-yellow-500 hover:bg-yellow-600',
      onClick: () => onAction?.('approval-workflow')
    },
    {
      icon: Bell,
      label: 'Centre de Notifications',
      color: 'bg-red-500 hover:bg-red-600',
      onClick: () => onAction?.('notification-center')
    }
  ];

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-gray-900">Actions Rapides</h3>
        <Link
          to="/asset-management-hub"
          className="flex items-center gap-1.5 text-sm text-indigo-600 hover:text-indigo-800 font-medium transition-colors"
        >
          <Layers size={14} /> Hub Assets 3D
        </Link>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-8 gap-4">
        {quickActions?.map((action, index) => {
          const IconComponent = action?.icon;
          return (
            <button
              key={index}
              onClick={action?.onClick}
              className={`${action?.color} text-white p-4 rounded-lg transition-colors duration-200 flex flex-col items-center space-y-2 hover:shadow-md`}
            >
              <IconComponent className="h-6 w-6" />
              <span className="text-xs font-medium text-center leading-tight">
                {action?.label}
              </span>
            </button>
          );
        })}
      </div>
      
      {/* Additional Management Actions */}
      <div className="mt-6 pt-6 border-t border-gray-200">
        <div className="flex flex-wrap gap-2">
          <Button
            variant="outline"
            size="sm"
            onClick={onRefresh}
            className="flex items-center gap-2"
          >
            <BarChart3 className="h-4 w-4" />
            Rapport Hebdomadaire
          </Button>
          
          <Button
            variant="outline"
            size="sm"
            onClick={() => onAction?.('market-analysis')}
            className="flex items-center gap-2"
          >
            <FileText className="h-4 w-4" />
            Analyse Marché
          </Button>
          
          <Button
            variant="outline"
            size="sm"
            onClick={() => onAction?.('performance-tracking')}
            className="flex items-center gap-2"
          >
            <Settings className="h-4 w-4" />
            Suivi Performance
          </Button>
          
          <Button
            variant="outline"
            size="sm"
            onClick={() => onAction?.('bulk-operations')}
            className="flex items-center gap-2"
          >
            <FileText className="h-4 w-4" />
            Operations en Lot
          </Button>

          <Link to="/asset-management-hub">
            <Button
              variant="outline"
              size="sm"
              className="flex items-center gap-2 border-indigo-200 text-indigo-700 hover:bg-indigo-50"
            >
              <Layers className="h-4 w-4" />
              Hub Assets 3D
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default QuickActions;